import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css"
import {useLocation} from "react-router-dom";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import {IoIosCloseCircle, IoMdEye, IoMdTrash} from "react-icons/io";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import {Autocomplete} from "@mui/lab";

const EditInspectFile = ({onClose, onFileUpload, users, caseData, inspectFileDepartmentId, inspectFileData}) => {
    const [file, setFile] = useState(null);
    const [adminFile, setAdminFile] = useState(null);
    const [shared, setShared] = useState(false);
    const [adminFileTitle, setAdminFileTitle] = useState("ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);
    const [caseFileNumber, setCaseFileNumber] = useState('');
    const adminFileInputRef = useRef(null);
    const [inspectionDocumentImplementationDate, setInspectionDocumentImplementationDate] = useState(null);
    const [inpectOrderAttachmentDate, setInpectOrderAttachmentDate] = useState(null);
    const [inspectionDocumentCheckingDate, setInspectionDocumentCheckingDate] = useState(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [isCriticalInconsistenciesEnabled, setIsCriticalInconsistenciesEnabled] = useState(false);
    const [inconsistenciesCritical, setInconsistenciesCritical] = useState(null);
    const [inconsistenciesSubstantialEnabled, setInconsistenciesSubstantialEnabled] = useState(false);
    const [inconsistenciesSubstantial, setInconsistenciesSubstantial] = useState(null);
    const [inconsistenciesNonSubstantialEnabled, setInconsistenciesNonSubstantialEnabled] = useState(false);
    const [inconsistenciesNonSubstantial, setInconsistenciesNonSubstantial] = useState(null);
    const [violationFailureToConductInspectionEnabled, setViolationFailureToConductInspectionEnabled] = useState(false);
    const [violationHiddenExploitationEnabled, setViolationHiddenExploitationEnabled] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const inspectionUsers = users.filter(user => user.departmentId === inspectFileDepartmentId && user.roleName === "Expert")
    const disableUpload = isUploading ||
        (inconsistenciesSubstantialEnabled && inconsistenciesSubstantial === null) ||
        (isCriticalInconsistenciesEnabled && inconsistenciesCritical === null) ||
        (inconsistenciesNonSubstantialEnabled && inconsistenciesNonSubstantial === null) ||
        inspectionDocumentImplementationDate === null ||
        inspectionDocumentCheckingDate === null ||
        caseFileNumber === '' ||
        selectedUsers.length === 0
    const [roleId, setRoleId] = useState('');


    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };


    useEffect(() => {
        if (!inconsistenciesSubstantialEnabled) {
            setInconsistenciesSubstantial(null);
        }
        if (!isCriticalInconsistenciesEnabled) {
            setInconsistenciesCritical(null);
        }
        if (!inconsistenciesNonSubstantialEnabled) {
            setInconsistenciesNonSubstantial(null);
        }

    }, [inconsistenciesSubstantialEnabled,
        isCriticalInconsistenciesEnabled,
        inconsistenciesNonSubstantialEnabled,
        violationFailureToConductInspectionEnabled,
        violationHiddenExploitationEnabled]);


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setFile(null);
            } else {
                setFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    };
    const handleAdminFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setAdminFile(null);
            } else {
                setAdminFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    }


    const handelDeleteFile = () => {
        setAdminFile(null)
        adminFileInputRef.current.value = ''
        setInpectOrderAttachmentDate(null)
    };
    const handelDeleteMainFile = () => {
        fileInputRef.current.value = ''
        setFile(null)
    };


    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [onClose]);


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {

        const payload = {
            caseId: caseId,
            inspectionDocumentCheckingDate: inspectionDocumentCheckingDate ? inspectionDocumentCheckingDate.toISOString() : null,
            inspectionDocumentmplementation: inspectionDocumentImplementationDate ? inspectionDocumentImplementationDate.toISOString() : null,
            inspectionSertificatValidityPeriodDate: caseData.inspectionSertificatValidityPeriodDate
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseSertificatAndInspectionInfo`, payload);
            if (!response.data.success) {
                return
            }
        } catch (error) {
            return
        }

        setIsUploading(true);


        const fileData = {
            ...inspectFileData,
            isInspectFile: true,
            inspectionDocumentmplementation: inspectionDocumentImplementationDate ? inspectionDocumentImplementationDate.toISOString() : null,
            inspectionDocumentCheckingDate: inspectionDocumentCheckingDate ? inspectionDocumentCheckingDate.toISOString() : null,
            violationFailureToConductInspection: violationFailureToConductInspectionEnabled ? 1 : 0,
            violationHiddenExploitation: violationHiddenExploitationEnabled ? 1 : 0,
            inconsistenciesCritical: isCriticalInconsistenciesEnabled ? inconsistenciesCritical : null,
            inconsistenciesSubstantial: inconsistenciesSubstantialEnabled ? inconsistenciesSubstantial : null,
            inconsistenciesNonSubstantial: inconsistenciesNonSubstantial ? inconsistenciesNonSubstantial : null,
            expertIdsWhoWorking: selectedUsers,
            caseFileNumber: caseFileNumber
        };


        try {
            const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, fileData);
            if (response.data.resultId !== null) {
                await sendNotification(response.data.resultId)
                setAlert({show: true, message: 'დოკუმენტი აიტვირთა წარმატებით!', type: 'success'});

                if (adminFile) {
                    const adminFileBase64 = await toBase64(adminFile);
                    const adminFileData = {
                        caseID: caseId,
                        name: adminFileTitle ? adminFileTitle : "ადმინისტრაციული სამართალდარღვევის შესახებ ოქმი",
                        ext: file.name.split('.').pop(),
                        file: adminFileBase64,
                        mainInfo: '',
                        additionalInfo: '',
                        shared: shared,
                        sharedTemp: shared,
                        parentId: response.data.resultId,
                        blank: false,
                        documentType: 0,
                        internal: CaseFilesInternal.Yes,
                        status: CaseFilesStatus.SentForVisage,
                        decline: CaseFileDeclined.No,
                        isUploaded: true,
                        approvalDocument: false,
                        declinedInternalStatus: 0,
                        inpectOrderAttachment: true,
                        inpectOrderAttachmentDate: inpectOrderAttachmentDate ? inpectOrderAttachmentDate.toISOString() : null
                    };
                    try {
                        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, adminFileData);
                    } catch (error) {
                        setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'});
                    }

                }

            } else {
                setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'})
            }
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'});
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);
            onFileUpload();
            onClose();
        }
    };


    return (
        <div>
            <div className="upload-single-popup">
                <div className="upload-single-container-inspection">
                    <IoIosCloseCircle className="upload-single-close-icon-inspection"
                                      onClick={onClose}>Close</IoIosCloseCircle>
                    <div className="upload-single-header">
                        <p className="upload-single-title">ინსპექტირების ოქმი</p>
                    </div>

                    <div className="upload-single-body">
                        {file && <div className="upload-single-selected-file">
                            <span>{file.name}</span>
                            <div className="file-actions">
                                <div style={{marginTop: 5}}>
                                    <IoMdEye
                                        className="file-icon preview-icon"
                                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                                    />

                                    <IoMdTrash
                                        className="file-icon delete-icon"
                                        onClick={handelDeleteMainFile}
                                    />
                                </div>
                            </div>
                        </div>}


                        <div style={{display: "flex", gap: 15}}>
                            <div className={"inconsistencies-container"}>
                                <TextField
                                    type="text"
                                    fullWidth
                                    label="დოკუმენტის ნომერი"
                                    variant="outlined"
                                    value={caseFileNumber}
                                    onChange={(e) => setCaseFileNumber(e.target.value)}
                                    InputProps={{inputProps: {min: 1}}}
                                />
                                <div>
                                    <FormControlLabel
                                        style={{marginRight: 70}}
                                        control={<Checkbox checked={isCriticalInconsistenciesEnabled}
                                                           onChange={(e) => {
                                                               setIsCriticalInconsistenciesEnabled(e.target.checked);
                                                               if (!e.target.checked) {
                                                                   setInconsistenciesCritical(null);
                                                               }
                                                           }}/>}
                                        label="კრიტიკული შეუსაბამომებები"
                                    />

                                    <TextField
                                        type="number"
                                        style={{width: 270}}
                                        label="კრიტიკული შეუსაბამომებები"
                                        variant="outlined"
                                        value={inconsistenciesCritical || ''}
                                        onChange={(e) => setInconsistenciesCritical(Math.max(1, parseInt(e.target.value) || 0))}
                                        disabled={!isCriticalInconsistenciesEnabled}
                                        InputProps={{inputProps: {min: 1}}}
                                    />
                                </div>
                                <div>
                                    <FormControlLabel
                                        style={{marginRight: 89}}
                                        control={<Checkbox checked={inconsistenciesSubstantialEnabled}
                                                           onChange={(e) => {
                                                               setInconsistenciesSubstantialEnabled(e.target.checked);
                                                               if (!e.target.checked) {
                                                                   setInconsistenciesSubstantial(null);
                                                               }
                                                           }}/>}
                                        label="არსებითი შეუსაბამომებები"
                                    />
                                    <TextField
                                        type="number"
                                        style={{width: 270}}
                                        label="არსებითი შეუსაბამომებები"
                                        variant="outlined"
                                        value={inconsistenciesSubstantial || ''}
                                        onChange={(e) => setInconsistenciesSubstantial(Math.max(1, parseInt(e.target.value) || 0))}
                                        disabled={!inconsistenciesSubstantialEnabled}
                                        InputProps={{inputProps: {min: 1}}}
                                    />
                                </div>
                                <div>
                                    <FormControlLabel
                                        style={{marginRight: 64}}
                                        control={<Checkbox checked={inconsistenciesNonSubstantialEnabled}
                                                           onChange={(e) => {
                                                               setInconsistenciesNonSubstantialEnabled(e.target.checked);
                                                               if (!e.target.checked) {
                                                                   setInconsistenciesNonSubstantial(null);
                                                               }
                                                           }}/>}
                                        label="არაარსებითი შეუსაბამომებები"
                                    />
                                    <TextField
                                        type="number"
                                        label="არაარსებითი შეუსაბამომებები"
                                        variant="outlined"
                                        style={{width: 270}}
                                        value={inconsistenciesNonSubstantial || ''}
                                        onChange={(e) => setInconsistenciesNonSubstantial(Math.max(1, parseInt(e.target.value) || 0))}
                                        disabled={!inconsistenciesNonSubstantialEnabled}
                                        InputProps={{inputProps: {min: 1}}}
                                    />
                                </div>
                            </div>
                            <div className={"inconsistencies-container"}>
                                <div>
                                    <FormControlLabel
                                        style={{marginRight: 15}}
                                        control={<Checkbox checked={violationFailureToConductInspectionEnabled}
                                                           onChange={(e) => {
                                                               setViolationFailureToConductInspectionEnabled(e.target.checked);

                                                           }}/>}
                                        label="ინსპექტირების ჩაუტარებლობა დარღვევა"
                                    />

                                </div>
                                <div>
                                    <FormControlLabel
                                        style={{marginRight: 60}}
                                        control={<Checkbox checked={violationHiddenExploitationEnabled}
                                                           onChange={(e) => {
                                                               setViolationHiddenExploitationEnabled(e.target.checked);

                                                           }}/>}
                                        label="ფარული ექსპლუატაცია დარღვევა"
                                    />

                                </div>
                                <div>
                                    <FormControl fullWidth variant="outlined">
                                        <Autocomplete
                                            multiple
                                            noOptionsText="არაფერი მოიძებნა!"
                                            id="select-experts"
                                            options={inspectionUsers}
                                            value={inspectionUsers.filter(user => selectedUsers.includes(user.id))}
                                            onChange={(event, newValue) => {
                                                setSelectedUsers(newValue.map(user => user.id));
                                            }}
                                            getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label="ინსპექტორები"
                                                    placeholder="ინსპექტორები"
                                                />
                                            )}
                                        />
                                    </FormControl>


                                </div>


                            </div>
                        </div>

                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div style={{}}>
                                <div className="full-width">
                                    <p>განხორციელების თარიღი:</p>
                                    <DatePicker
                                        selected={inspectionDocumentImplementationDate}
                                        onChange={(date) => setInspectionDocumentImplementationDate(date)}
                                        locale={ka}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="აირჩიეთ თარიღი"
                                        className="full-width"
                                    />
                                </div>

                                <div className="full-width">
                                    <p>გადამოწმების თარიღი:</p>
                                    <DatePicker
                                        selected={inspectionDocumentCheckingDate}
                                        onChange={(date) => setInspectionDocumentCheckingDate(date)}
                                        locale={ka}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        minDate={new Date()}
                                        placeholderText="აირჩიეთ თარიღი"
                                        className="full-width"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="upload-single-footer">
                            <div style={{width: "100%", cursor: file === null ? "not-allowed" : "pointer"}}>
                                <Button style={{width: "100%"}} onClick={() => setIsModalOpen(true)}
                                        disabled={disableUpload} variant="contained">
                                    {isUploading ? 'ატვირთვა...' : 'დოკუმენტის ატვირთვა'}
                                </Button>
                            </div>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                />

            </div>
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>

    );
};

export default EditInspectFile;
